module.exports = __webpack_public_path__ + "static/media/background-pos.e70fc9d1.svg";